import React, { Fragment } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { Route, withRouter, Redirect } from "react-router-dom";
import ResizeDetector from "react-resize-detector";
import AppMain from "../../Layout/AppMain";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppHeader from "../../Layout/AppHeader";
import VerticalNavWrapper from "../../Layout/AppNav/VerticalNavWrapper";
import ReportForm from "../Form/ReportForm/index";
import NotFound from "../NotFound";
import ScreenViewLogger from "../../ScreenViewLogger/index";
// List of routes that should be accessible without authentication
const PUBLIC_ROUTES = ['/Dhanshakthi-AdminLogin', '/reportform'];

// List of valid authenticated routes
const VALID_AUTH_ROUTES = [
  '/components',
  '/forms',
  '/records',
  '/qrcode',
  '/points',
  '/charts',
  '/reports',
  '/tables',
  '/addcompany',
  '/addpersonnel',
  '/widgets',
  '/pages',
  '/apps',
  '/giftscheme',
  '/dashboards',
  '/personaldashboard',
  '/giftmanagementelectirician',
  '/giftmanagementDealer',
  '/uploadPoints',
  '/saleorders',
  '/reportform',
    '/talleyData',
  '/sales'
];

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closedSmallerSidebar: false,
      isSidebarOpen: true
    };
  }

  toggleSidebar = () => {
    this.setState(prev => ({ isSidebarOpen: !prev.isSidebarOpen }));
  };

  isRouteValid = (pathname) => {
    // Check if route starts with any valid path
    return VALID_AUTH_ROUTES.some(route => 
      pathname === route || pathname.startsWith(`${route}/`)
    );
  };

  render() {
    let {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      enableClosedSidebar,
      closedSmallerSidebar,
      enableMobileMenu,
      enablePageTabsAlt,
      location
    } = this.props;

    const { isSidebarOpen } = this.state;

    // Check if user is authenticated
    const isAuthenticated = sessionStorage.getItem("adminId") ? atob(sessionStorage.getItem("adminId")) : null;
    
    // Check if current route is public
    const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);

    // If not authenticated and not a public route
    if (!isAuthenticated && !isPublicRoute) {
      // Redirect root route to login
      if (location.pathname === '/Dhanshakthi-AdminLogin') {
        return <Redirect to="/Dhanshakthi-AdminLogin" />;
      }
      // For all other non-public routes, show 404
      return <NotFound />;
    }









    
    // Special handling for login page
    if (location.pathname === '/Dhanshakthi-AdminLogin') {
      return (
        <Fragment>
          <AppMain isSidebarOpen={isSidebarOpen} />
          <ToastContainer
            position="top-center"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Fragment>
      );
    }

    // Special handling for report form
    if (location.pathname === '/reportform') {
      return (
        <Fragment>
          <ReportForm />
          <ToastContainer
            position="top-center"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Fragment>
      );
    }

    // For authenticated users, redirect to dashboard if route is invalid
    if (isAuthenticated && !this.isRouteValid(location.pathname)) {
      return <Redirect to="/dashboards/crm" />;
    }

    return (
      <Fragment>
            <ScreenViewLogger>
        {/* Render Sidebar and Header only if authenticated */}
        {isAuthenticated && (
          <VerticalNavWrapper 
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={this.toggleSidebar}
          />
        )}
        
        <div
          className={cx(
            "app-container app-theme-" + colorScheme,
            { "fixed-header": enableFixedHeader },
            { "fixed-sidebar": enableFixedSidebar },
            { "fixed-footer": enableFixedFooter },
            { "closed-sidebar": enableClosedSidebar },
            { "closed-sidebar-mobile": closedSmallerSidebar },
            { "sidebar-mobile-open": enableMobileMenu },
            { "body-tabs-shadow-btn": enablePageTabsAlt }
          )}
          style={{
            marginLeft: isAuthenticated ? (isSidebarOpen ? "260px" : "80px") : "0",
            transition: "margin-left 0.4s ease",
            position: "relative",
            zIndex: 1
          }}
        >
          {/* Render AppHeader only if authenticated */}
          {isAuthenticated && <AppHeader />}
          <AppMain isSidebarOpen={isSidebarOpen} />
        </div></ScreenViewLogger>
      </Fragment>
    );
  }
}

const mapStateToProp = (state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
});

export default withRouter(connect(mapStateToProp)(Main));